export const isValidApiCollection = async (file: File): Promise<boolean> => {
  try {
    const text = await file.text();
    const json = JSON.parse(text);

    return (
      json &&
      typeof json === "object" &&
      json.info &&
      json.item &&
      typeof json.info === "object" &&
      typeof json.item === "object" &&
      typeof json.info.schema === "string" &&
      json.info.schema.toLowerCase().includes("postman")
    );
  } catch (error) {
    console.error("Invalid JSON:", error);
    return false;
  }
};
